// extracted by mini-css-extract-plugin
export default {"body":"Gastos_body__rGiC9","content":"Gastos_content__D+Ug6","menuGroup":"Gastos_menuGroup__9-iw+"};